<template>
  <div class="flex min-h-screen h-screen bg-white">
    <div
      class="flex flex-col justify-center flex-1 px-4 py-12 bg-teal-1 00 sm:px-6 lg:flex-none lg:px-20 xl:px-24"
    >
      <router-view />
    </div>
    <div class="relative flex-1 hidden w-0 lg:block">
      <img
        class="absolute inset-0 object-cover w-full h-full"
        src="../assets/login-splash.jpg"
        alt=""
      >
    </div>
  </div>
</template>
<script setup lang="ts"></script>
